import React from "react";
import {
  AbsoluteFill,
  Img,
  interpolate,
  staticFile,
  useCurrentFrame,
} from "remotion";
import Icon1 from "./icons/Icon1";
import { useLanguage } from "../../locales/LanguageContext";

const LogoSrc = staticFile("images/standard_chartered.png");

const ThirdFrame = () => {
  const frame = useCurrentFrame();
  const { t, lang } = useLanguage();

  const extractSourceList = Array.isArray(t?.thirdFrame?.extractSource)
    ? t.thirdFrame.extractSource
    : [t?.thirdFrame?.extractSource].filter(Boolean);

  const stage2List = Array.isArray(t?.thirdFrame?.stage2)
    ? t.thirdFrame.stage2
    : [];

  const stage3Raw = t?.thirdFrame?.stage3;
  const stage3List = Array.isArray(stage3Raw) ? stage3Raw : [];
  const hasStage3 = stage3List.length > 0;

  const offsetX = interpolate(frame, [0, 60, 90], [-80, -80, -400], {
    extrapolateRight: "clamp",
  });

  return (
    <AbsoluteFill style={{ overflow: "hidden" }}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "43%",
          transform: `translatey(-50%) translateX(${offsetX}px)`,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: "40px",
          fontSize: "20rem",
          opacity: interpolate(frame, [0, 20, 280, 300], [0, 1, 1, 0], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          }),
        }}
      >
        <Icon1 />
        <div
          style={{
            opacity: interpolate(frame, [0, 60, 90], [0, 0, 1], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            }),
          }}
        >
          <Img
            src={LogoSrc}
            alt="Logo"
            style={{ height: "450px", width: "auto" }}
          />
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `translateY(-50%) translateX(-50%)`,
          width: "80%",
          textAlign: "center",
          opacity: interpolate(
            frame,
            [0, 300, 340, 520, 560],
            [0, 0, 1, 1, 0],
            {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            },
          ),
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {extractSourceList.map((text, index) => (
          <h1
            key={index}
            style={{
              fontSize: "2.5rem",
              fontWeight: "500",
              fontFamily: "Roboto, sans-serif",
              margin: 0,
              padding: 0,
              zIndex: 10,
              whiteSpace: "pre-line",
            }}
          >
            {text}
          </h1>
        ))}
      </div>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          marginTop: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: interpolate(
            frame,
            hasStage3 ? [0, 520, 560, 740, 780] : [0, 520, 560],
            hasStage3 ? [0, 0, 1, 1, 0] : [0, 0, 1],
            {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            },
          ),
        }}
      >
        <div
          style={{
            fontSize: lang === "en" ? "1.1rem" : "0.74rem",
            fontWeight: "900",
            color: "#88b7eb",
            fontFamily: "Roboto",
            margin: 0,
            paddingLeft: 28,
            paddingRight: 28,
            zIndex: 10,
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "column",
            gap: "0.5rem",
            width: "100%",
            textAlign: "right",
          }}
        >
          {stage2List.map((item, index) => (
            <p
              key={index}
              style={{
                fontSize:
                  index === 0 ? "1.2rem" : index === 3 ? "1rem" : undefined,
                fontWeight: "900",
                textAlign: "right",
                width: "100%",
                margin: 0,
              }}
            >
              {item}
            </p>
          ))}
        </div>
      </div>
      {hasStage3 && (
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            marginTop: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: interpolate(frame, [0, 740, 780], [0, 0, 1], {
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp",
            }),
          }}
        >
          <div
            style={{
              fontSize: lang === "en" ? "1.1rem" : "0.74rem",
              fontWeight: "900",
              color: "#88b7eb",
              fontFamily: "Roboto",
              margin: 0,
              paddingLeft: 28,
              paddingRight: 28,
              zIndex: 10,
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "column",
              gap: "0.5rem",
              width: "100%",
              textAlign: "right",
            }}
          >
            {stage3List.map((item, index) => (
              <p
                key={index}
                style={{
                  fontSize:
                    index === 0
                      ? "1.2rem"
                      : index % 2 === 0
                        ? "1rem"
                        : undefined,
                  fontWeight: "900",
                  textAlign: "right",
                  width: "100%",
                  margin: 0,
                }}
              >
                {item}
              </p>
            ))}
          </div>
        </div>
      )}
    </AbsoluteFill>
  );
};

export default ThirdFrame;
